import { render, staticRenderFns } from "./AddSpecialRequirementModal.vue?vue&type=template&id=88934e4c&scoped=true&"
import script from "./AddSpecialRequirementModal.vue?vue&type=script&lang=js&"
export * from "./AddSpecialRequirementModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSpecialRequirementModal.vue?vue&type=style&index=0&id=88934e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88934e4c",
  null
  
)

export default component.exports